/* import __COLOCATED_TEMPLATE__ from './seller-posting-textarea.hbs'; */
import clsx from 'clsx';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object';

const CLASS_NAME = 'seller-posting-input';
const CLASS_NAME_ACTIVE = `${CLASS_NAME}--active`;
const CLASS_NAME_ERROR = `${CLASS_NAME}--error`;

class SellerPostingTextareaComponent extends Component {
  @tracked focus = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.focus && CLASS_NAME_ACTIVE,
      Boolean(this.args.error) && CLASS_NAME_ERROR,
    );
  }

  get hasError() {
    return Boolean(this.args.error);
  }

  get rows() {
    return this.args.rows ?? 3;
  }

  /**
   *
   */
  @action
  handleFocus() {
    this.focus = true;
    this.args.onfocus?.();
  }

  /**
   *
   */
  @action
  handleBlur() {
    this.focus = false;
    this.args.onblur?.();
  }

  /**
   * @param {InputEvent} e
   */
  @action
  handleInput({ target }) {
    this.args.oninput?.(target.value);
  }

  /**
   * @param {KeyboardEvent} e
   */
  @action
  handleKeyDown(e) {
    this.args.onkeydown?.(e);
  }
}

export default SellerPostingTextareaComponent;
